import React, {useEffect, useState} from 'react';
import {withRouter} from 'react-router-dom';
import Landing from "../components/landing";
import {_findQuote} from '../store/policy/service';
import {connect} from 'react-redux';
import Gears from '../assets/Gears.svg';
import QbeLogo from '../assets/QBE_Logo_Complete.jpg';
import Tts from "../ui/tts/tts";
import {
    _getSite,
    _hideModal,
    _setSite,
    _showModal,
    _checkPaynowAvailable,
    _checkSystemAvailable,
    _getScheduledMaintenance
} from "../store/system/service";
import {useTranslation} from "react-i18next";
import {_gaPushData} from "../utils/utility";
import {_getPolicy} from "../store/policy/service";


const MainPage = (props) => {
    const {i18n} = useTranslation();
    const [test, setTest] = useState({
        isCalled: false,
        nextPage: 'initial'
    });

    useEffect(() => {
        if (test.nextPage == 'landing') {
            const params = new URLSearchParams(props.location.search);
            _gaPushData({
                'pageStep': 'Home',
                'vPath': '/home',
                'event': 'vpageview',
                'campaignCode': props.policy.promotionCode || 'N/A',
                'agentcode': props.policy.agentCode,
                'language': i18n.language,
                'utm_source': params.get('utm_source') || 'N/A',
                'utm_medium': params.get('utm_medium') || 'N/A',
                'utm_campaign': params.get('utm_campaign') || 'N/A',
                'ecommerce': {
                    'checkout': {
                        'actionField': {'step': 1}
                    }
                }
            });
        } else if (test.nextPage == 'redirect') {
            _gaPushData({
                'pageStep': 'Redirect',
                'vPath': '/redirect',
                'event': 'vpageview',
                'ecommerce': {'checkout': {'actionField': {'step': 1, 'option': 'SaveResume'},}}

            })
        }
        props.checkSystemAvailable();
        props.getScheduledMaintenance();
        props.checkPaynowAvailable();
    }, [test]);

    if (props.location.hash) {
        if (props.location.hash === "#path") {
            return (<Tts/>);
        } else {
            let quoteId = props.location.hash.split("/")[2];
            if (quoteId !== '') {
                props.findQuote(quoteId).then((result) => {
                    if (!test.isCalled) {
                        setTest({
                            isCalled: true,
                            nextPage: 'redirect'
                        });
                    }
                    props.history.push(result.page);
                }, () => {
                    // if errors found, go to landing page...
                    props.showModal({
                        title: 'Resume Link Expired',
                        content: (
                            <div>
                                <p>Your online quotation resume link has expired.</p>
                                <p>Please start over by pressing Start Quote button.</p>
                            </div>
                        ),
                        primaryAction: {
                            label: 'OK',
                            onClick: () => {
                                props.hideModal();
                            }
                        }
                    });
                    props.history.push((props.site ? "/" + props.site : "/"));
                    if (!test.isCalled) {
                        setTest({
                            isCalled: true,
                            nextPage: 'landing'
                        });
                    }
                });
                return (
                    <>
                        <div id="splash-screen">
                            <div id="gears-box">
                                <img src={Gears} height="160"/>
                            </div>
                            <div id="logo-box">
                                <img src={QbeLogo} height="90"/>
                            </div>
                        </div>
                    </>
                );
            }
        }
    } else {
        if (!test.isCalled) {
            setTest({
                isCalled: true,
                nextPage: 'landing'
            });
        }
        return (
            <Landing site={props.site}/>
        );
    }
}

const mapStateToProps = (state) => {
    const policy = _getPolicy(state);
    return {
        site: _getSite(state),
        policy: policy
    }
}

const mapDispatchToProps = {
    findQuote: _findQuote,
    setSite: _setSite,
    showModal: _showModal,
    hideModal: _hideModal,
    checkPaynowAvailable: _checkPaynowAvailable,
    checkSystemAvailable: _checkSystemAvailable,
    getScheduledMaintenance: _getScheduledMaintenance
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(MainPage));
